import React, { ReactElement } from "react";
import SalesReportList from "../../components/Finance/SalesReport";
import Layout from "../../components/layout";

const SalesReportPage = (): ReactElement => {
  return (
    <Layout>
      <SalesReportList />
    </Layout>
  );
};

export default SalesReportPage;
